import { useCallback, useEffect, useState } from "react";
import { useFetcher } from "react-router";
import { $path } from "safe-routes";
import type { ILinkWithAvailability } from "~/models/link";
import type { loader } from "~/routes/resources+/artists.$artistId.links";

export function useLinks({
  artistUid,
  enabled = true,
  scope,
}: {
  artistUid?: string;
  enabled?: boolean;
  scope?: "social" | "distribution";
} = {}) {
  const [links, setLinks] = useState<Array<ILinkWithAvailability>>([]);
  const [isLoading, setIsLoading] = useState(!!artistUid && enabled);

  const fetcher = useFetcher<typeof loader>({
    key: "links",
  });

  const refetch = useCallback(() => {
    if (artistUid && enabled) {
      setIsLoading(true);
      fetcher.load(
        $path("/resources/artists/:artistId/links", {
          artistId: artistUid,
        }),
      );
    }
  }, [artistUid, enabled]);

  useEffect(() => {
    if (fetcher.data) {
      const links = fetcher.data.links ?? [];
      setLinks(
        !scope ? links : links.filter((link) => link.availability[scope]),
      );
    }
  }, [fetcher.data, scope]);

  useEffect(() => {
    refetch();
  }, [artistUid, enabled]);

  useEffect(() => {
    if (fetcher.state === "idle") {
      setIsLoading(false);
    }
  }, [fetcher.state]);

  return {
    links,
    isLoading,
    refetch,
  };
}
